import { useEffect, useState } from "react";
import { useGetUserByIdQuery } from "services";
import { telefonoIcon } from "examples/TelefonosCRUD/telefonos.add";

export const usePlantillaFetch = (id, setFieldValue, formField) => {
  const [oldValues, setOldValues] = useState();

  const { data: usuario } = useGetUserByIdQuery(
    {
      id: id,
      shape: {
        id: "id",
        url: "url",
        nombre: "nombre",
        apellido_paterno: "apellido_paterno",
        apellido_materno: "apellido_materno",
        email: "email",
        resourcetypeFull: "perfil.resourcetype",
        telefonos: "perfil.telefonos",
        foto: "foto",
        groups: "groups",
      },
    },
    { skip: !id, refetchOnReconnect: true, refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (id && usuario) {
      setOldValues(usuario);
      setFieldValue(formField.nombre.name, usuario?.nombre, true);
      setFieldValue(
        formField.apellido_paterno.name,
        usuario?.apellido_paterno,
        true
      );
      setFieldValue(
        formField.apellido_materno.name,
        usuario?.apellido_materno,
        true
      );
      setFieldValue(formField.correo.name, usuario?.email, true);
      setFieldValue(formField.foto.name, usuario?.foto, true);
      setFieldValue(
        formField.groups.name,
        usuario?.groups.map((e) => e.id),
        true
      );
      setFieldValue(
        formField.telefonos.name,
        usuario?.telefonos?.map((el) => ({
          ...el,
          isCreated: false,
          icon: telefonoIcon(el.tipo),
        })) || [],
        true
      );
    }
  }, [id, usuario, setFieldValue, formField]);

  return { oldValues };
};
